import I18n from 'i18n-js';
import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import {
  reverb_search_ListingItemRegionRelation as ItemRegionRelation,
} from '@reverbdotcom/commons/src/gql/graphql';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';
import { EUROPEAN_UNION_COUNTRY_CODES, isEU } from '@reverbdotcom/commons/src/geo';

const EU_DOMESTIC_SHOPS_ONLY_COUNTRIES = ['FR', 'NL', 'ES', 'IT'];

export function isInEUShopRowsExp(user: Partial<IUser>) {
  return isExperimentEnabled(user, experiments.EU_SHOP_ROWS_V2) && isEU(user.countryCode);
}

export function shopRowItemRegionFilters(user: Partial<IUser>) {
  if (!user.countryCode) { return {}; }

  return {
    ...withItemRegionRelationShopRows(user),
    itemRegion: user.countryCode,
  };
}

function withItemRegionRelationShopRows(user: Partial<IUser>) {
  if (isInEUShopRowsExp(user) && !EU_DOMESTIC_SHOPS_ONLY_COUNTRIES.includes(user.countryCode)) {
    return {
      itemRegionRelation: ItemRegionRelation.INCLUDE_TRADE_REGIONS,
    };
  }

  return {};
}

export function itemPageShopsRowTitle(user: Partial<IUser>) {
  if (user.countryCode === 'GB') {
    return I18n.t('discovery.shopCard.recommendedShopsTitle.gb');
  } else if (user.countryCode === 'NL') {
    return I18n.t('discovery.shopCard.recommendedShopsTitle.nl');
  } else if (EU_DOMESTIC_SHOPS_ONLY_COUNTRIES.includes(user.countryCode)) {
    const countryTranslation = I18n.t(`discovery.shippingRegions.${user.countryCode}`);
    return I18n.t('discovery.shopCard.recommendedShopsTitle.inCountry', { country: countryTranslation });
  } else if (isEU(user.countryCode)) {
    return I18n.t('discovery.shopCard.recommendedShopsTitle.eu');
  } else {
    return I18n.t('discovery.shopCard.recommendedShopsTitle.default');
  }
}

const BROWSE_PAGE_COUNTRY_CODES_TO_LOCALIZE = ['AU', 'BR', 'CA', 'GB', 'NL', 'NO', ...EUROPEAN_UNION_COUNTRY_CODES];

export function browsePageShopsRowTitle(user: Partial<IUser>): string {
  if (user.countryCode === 'GB') {
    return I18n.t('discovery.shopCard.recommendedShopsTitle.gb');
  } else if (user.countryCode === 'NL') {
    return I18n.t('discovery.shopCard.recommendedShopsTitle.nl');
  } else if (BROWSE_PAGE_COUNTRY_CODES_TO_LOCALIZE.includes(user.countryCode)) {
    const countryTranslation = I18n.t(`discovery.shippingRegions.${user.countryCode}`);
    return I18n.t('discovery.shopCard.recommendedShopsTitle.inCountry', { country: countryTranslation });
  } else {
    return I18n.t('discovery.shopCard.recommendedShopsTitle.default');
  }
}

export function showItemPageShopRow(user: Partial<IUser>) {
  return (user.countryCode === 'GB') || isInEUShopRowsExp(user);
}
